import { MemberInviteInterface, MemberInviteStatus } from "@swivl-mono/types";
import { Button, ButtonColor, LocationAvatar } from "@swivl-mono/ui";
import AccountModel from "../../Models/Account/AccountModel";

interface Props {
  invite: MemberInviteInterface;
}

export function InviteAcceptComponent(props: Props) {
  const { invite } = props;
  let buttonsArea: JSX.Element | null = null;
  if (invite.status === MemberInviteStatus.ACCEPTED) {
    buttonsArea = <div>Accepted</div>
  } else if (invite.status === MemberInviteStatus.DENIED || invite.status === MemberInviteStatus.REVOKED) {
    buttonsArea = <div>Denied</div>
  } else {
    buttonsArea = <div className="flex flex-row">
      <Button color={ButtonColor.WHITE}
        onClickAsync={async () => {
          await AccountModel.denyInvite(invite.id);
        }}>Deny </Button>
      <Button
        className="ml-2"
        color={ButtonColor.BLACK}
        onClickAsync={async () => {
          await AccountModel.acceptInvite(invite.id);
        }}
      >Accept</Button>
    </div>
  }

  return <div className="bg-white border rounded-sm w-full p-3 flex flex-row items-center justify-center">
    <LocationAvatar src={invite.org?.avatarURL} />
    <div className="flex-1 flex flex-col items-start justify-center px-3">{invite.org?.name}</div>
    {buttonsArea}

  </div>
}